const rejectHeaderData = [
  {
    prop: "id",
    label: "序号",
    columnwidth: 50,
  },
  {
    prop: "LicenseType",
    label: "证照类型",
    columnwidth: 180,
  },
  {
    prop: "ID",
    label: "证照ID",
    columnwidth: 310,
  },
  {
    prop: "RejectTime",
    label: "驳回时间",
    columnwidth: 130,
  },
  {
    prop: "RejecterName",
    label: "驳回人",
    columnwidth: 180,
  },
  {
    prop: "RejectReason",
    label: "驳回原因",
    columnwidth: 220,
  },
];
export default rejectHeaderData;
